import StoreIcon from '@mui/icons-material/Store';

import AddressList from './AddressList';
import AddressCreate from './AddressCreate';
import AddressShow from './AddressShow';
import AddressEdit from './AddressEdit';

const addresses = {
	list: AddressList,
	create: AddressCreate,
	show: AddressShow,
	edit: AddressEdit,
	icon: StoreIcon
};

export default addresses;
